import { useEffect, useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';



const EkycReport = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_URL_SIDE}/api/reports/ekyc-district-wise`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setReportData(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, []);


     if (loading) {
        return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
            <CircularProgress />
        </Box></div>
    }
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="py-10">
      <table className="w-[70%] m-auto text-right mb-10">
        <thead>
          <tr className="tableheader">
            <th colSpan="17">EKYC Report</th>
          </tr>
          <tr className="tableheader" style={{ backgroundColor: "#f2f2f2" }}>
            <th className="p-3">S.No.</th>
            <th className="p-3">District Name</th>
            <th className="p-3">Total Members</th>
            <th className="p-3">eKYC Completed</th>
            <th className="p-3">eKYC Pending</th>
          </tr>
        </thead>
        <tbody>
          {reportData.map((row, index) => (
            <tr key={index}>
              <td className="p-3 text-center">{index + 1}</td>
              <td style={{ padding: "8px", textAlign: "left" }}>
                {row.districtName}
              </td>
              <td style={{ padding: "8px" }}>{row.totalMembers}</td>
              <td style={{ padding: "8px" }}>{row.completedKyc}</td>
              <td style={{ padding: "8px" }}>{row.pendingKyc}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EkycReport;
